import { Box, ButtonLink, Stack } from '@n26/nxd'
import { SmallArticleCard } from './SmallArticleCard'
import { SectionWrapper } from './SectionWrapper'
import { Link } from '@components/Link'
import { BlogPostCard } from '@components/BlogPostCard'
import type {
  BlogCategory,
  BlogPost,
} from '@customTypes/generated/contentfulGraphqlAPI'
import { useGetBlogUrl } from '@hooks/useGetBlogUrls'

type CategorySectionProps = {
  category: Pick<
    BlogCategory,
    'categoryName' | 'categoryDescription' | 'categorySlug'
  >
  articles: BlogPost[]
}

export function CategorySection({ category, articles }: CategorySectionProps) {
  const { categoryName, categoryDescription, categorySlug } = category || {}
  const categoryUrl = useGetBlogUrl('category', categorySlug)
  if (!articles.length) return null

  function BigArticlesGroup({ end }: { end: number }) {
    return (
      <Stack direction='horizontal' space='16'>
        {articles.slice(0, end).map((article, index) => (
          <BlogPostCard key={index} post={article} />
        ))}
      </Stack>
    )
  }

  function SmallArticlesGroup({ start }: { start: number }) {
    return (
      <Box display='flex' flexDirection='column' gap='12'>
        {articles.slice(start).map((article, index) => (
          <SmallArticleCard key={index} article={article} />
        ))}
      </Box>
    )
  }

  return (
    <SectionWrapper>
      <Stack direction='vertical' space='12'>
        <Stack direction='horizontal' align='center' space='12'>
          <Stack space='12'>
            <Link url={categoryUrl}>
              <h2 className='text-[21px] font-extended hover:text-teal'>
                {categoryName}
              </h2>
            </Link>
            <p className='text-16'>{categoryDescription}</p>
          </Stack>
          {categoryName && (
            <Box className='hidden sm:block'>
              <ButtonLink variant='secondary' size='small' href={categoryUrl}>
                {categoryName}
              </ButtonLink>
            </Box>
          )}
        </Stack>
        <Box display='flex' gap='16' className='flex-col lg:flex-row'>
          <Box className='max-w-none lg:max-w-[583px]'>
            <Box className='block sm:hidden'>
              <BigArticlesGroup end={1} />
            </Box>
            <Box className='hidden sm:block'>
              <BigArticlesGroup end={2} />
            </Box>
          </Box>
          <Box className='block sm:hidden'>
            <SmallArticlesGroup start={1} />
          </Box>
          <Box className='hidden sm:block'>
            <SmallArticlesGroup start={2} />
          </Box>
        </Box>
      </Stack>
    </SectionWrapper>
  )
}
